// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PublicationVersionFileReference
 */
export interface PublicationVersionFileReference {
  /**
   *
   */
  name?: string;
  /**
   *
   */
  path: string;
  /**
   * Reference to the file version, found in file history.
   */
  ref?: string;
}

/**
 * Check if a given object implements the PublicationVersionFileReference interface.
 */
export function instanceOfPublicationVersionFileReference(
  value: object
): value is PublicationVersionFileReference {
  if (!("path" in value) || value["path"] === undefined) return false;
  return true;
}

export function PublicationVersionFileReferenceFromJSON(
  json: any
): PublicationVersionFileReference {
  return PublicationVersionFileReferenceFromJSONTyped(json, false);
}

export function PublicationVersionFileReferenceFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PublicationVersionFileReference {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] == null ? undefined : json["name"],
    path: json["path"],
    ref: json["ref"] == null ? undefined : json["ref"],
  };
}

export function PublicationVersionFileReferenceToJSON(json: any): PublicationVersionFileReference {
  return PublicationVersionFileReferenceToJSONTyped(json, false);
}

export function PublicationVersionFileReferenceToJSONTyped(
  value?: PublicationVersionFileReference | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    path: value["path"],
    ref: value["ref"],
  };
}
